// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"AlcoholTooltipCommon_tooltipWrapper__8i0_l","tooltip":"AlcoholTooltipCommon_tooltip__WEGx1","arrow":"AlcoholTooltipCommon_arrow__RbRop"};